export const CommentActionTypes = {
  CREATE_COMMENT: "CREATE_COMMENT",
  CREATE_COMMENT_FULFILLED: "CREATE_COMMENT_FULFILLED",

  FETCH_COMMENTS: "FETCH_COMMENTS",
  FETCH_COMMENTS_FULFILLED: "FETCH_COMMENTS_FULFILLED",

  CLEAR_COMMENTS: "CLEAR_COMMENTS"
};
